export const SubstanceTagIds = {
    parent: "#dve_parent_substance",
    rendered: "#dve_rendered_substance",
    isSolid: "#dve_is_solid",
    isLiquid: "#dve_is_liquid",
    flowRate: "#dve_flow_rate",
    culledSubstnaces: "#dve_culled_substances",
};
